import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ReviewCartPageContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "1px"
});

export const PlaceOrderButton = styled(Button)({
	placeSelf: "flex-end",
	minWidth: "142px",
	margin: "16px 0"
});
